import React, { Component } from "react";
import { Col } from "reactstrap";
import FeatherIcon from 'feather-icons-react';
import "../../apppages/Home/css/register.css"
import CountUp from "react-countup";
class Counter2 extends Component {
  render() {
    return (
      <React.Fragment>
        {this.props.counters.map((counter, key) => (
          <Col md="2" xs="6" key={key} className="mt-2 mx-auto border-primary pt-2 for_home_cards">
            <div className="counter-box text-center p-3 rounded border-primary shadow overflow-hidden" style={{border: '1px solid #FF7F00'}}>
              <img src={counter.image} height="70" className="avatar avatar-small" alt="" />
              {/* <FeatherIcon icon={counter.iconName} className="fea icon-ex-md me-2" style={{ width: `56px` }}/>  */}
              <h2 className="mb-0 mt-4">
                <span className="counter-value">
                  {" "}
                  <CountUp
                    start={counter.start}
                    end={counter.value}
                    duration={12}
                  />
                </span>
                {counter.postfix}
              </h2>
              <h6 className="counter-head fontSize20">{counter.title}</h6>
            </div>
          </Col>
        ))}
      </React.Fragment>
    );
  }
}

export default Counter2;
